import {createReducer} from "redux-act";
import {fetchOddsByEvent, fetchOddsByEventFailed, fetchOddsByEventSuccess} from "modules/actions";
import {IOddEntity} from "modules/types/odds";

export interface IOddsReducer {
	byEventID: Record<number, IOddEntity>;
	isLoading: boolean;
}

const defaultState: IOddsReducer = {
	byEventID: {},
	isLoading: false,
};

export const odds = createReducer<typeof defaultState>({}, defaultState)
	.on(fetchOddsByEvent, (state) => ({
		...state,
		isLoading: true,
	}))
	.on(fetchOddsByEventSuccess, (state, payload) => ({
		...state,
		isLoading: false,
		byEventID: {
			...state.byEventID,
			[payload.event_id]: payload,
		},
	}))
	.on(fetchOddsByEventFailed, (state) => ({
		...state,
		isLoading: false,
	}));
